import React from "react";
import styled from "styled-components";

const ItemWrapper = styled.div<{ $decoratorColor?: string }>`
  display: flex;
  align-items: center;
  padding: 8px;
  padding-left: 12px;
  margin-bottom: 4px;
  cursor: pointer;
  overflow: hidden;
  border: 1px solid #e7e7e2;
  ${(props) => props.$decoratorColor && `border-left: 3px solid ${props.$decoratorColor};`}
  position: relative;

  &:hover {
    background-color: #f8f9fa;
  }
`;

const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;

  img {
    width: 16px;
    height: 16px;
    object-fit: cover;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

const ItemTitle = styled.p`
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemSubtitle = styled.small`
  font-size: 12px;
  line-height: 1.4;
  color: #6c757d;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ActionContainer = styled.div`
  flex-shrink: 0;
  margin-left: 8px;
`;

interface FavoritesSidebarItemProps {
  image: React.ReactNode;
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  onClick: () => void;
  decoratorColor?: string;
}

const FavoritesSidebarItem: React.FC<FavoritesSidebarItemProps> = ({
  image,
  title,
  subtitle,
  action,
  onClick,
  decoratorColor,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    // Don't trigger onClick if clicking on the action button area
    const target = e.target as HTMLElement;
    if (target.closest(".favorites-item-action")) {
      return;
    }
    onClick();
  };

  return (
    <ItemWrapper onClick={handleClick} $decoratorColor={decoratorColor}>
      <IconContainer>{image}</IconContainer>
      <ContentContainer>
        <ItemTitle>{title}</ItemTitle>
        <ItemSubtitle>{subtitle}</ItemSubtitle>
      </ContentContainer>
      {action && (
        <ActionContainer className="favorites-item-action">
          {action}
        </ActionContainer>
      )}
    </ItemWrapper>
  );
};

export default FavoritesSidebarItem;
